import isEmpty from 'lodash/isEmpty';
import flow from 'lodash/flow';

import { getQueryParams } from '@v4/common/utils/url';

const marketingParamsKeys = [
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_term',
    'utm_content',
    'utm_expid',
    'utm_referrer',
    'ad_id',
    'campaign_id',
    'pid',
    'l_source',
    'gclid',
    'fbclid',
    'adset_id',
];

export const extractMarketingParamsFromLocalStorage = () => {
    const extracredMarketingParams = {};
    const marketingParamsFromLocalStorage = localStorage.getItem('marketingParams');

    if (marketingParamsFromLocalStorage) {
        const marketingParamsFromLocalStorageDecoded = JSON.parse(marketingParamsFromLocalStorage);
        const paramsFromLocalStorage = marketingParamsFromLocalStorageDecoded.params;

        if (paramsFromLocalStorage) {
            for (const marketingParamKey of marketingParamsKeys) {
                if (paramsFromLocalStorage[marketingParamKey]) {
                    extracredMarketingParams[marketingParamKey] = paramsFromLocalStorage[marketingParamKey];
                }
            }
        }
    }

    return extracredMarketingParams;
};

(function() {
    const MARKETING_PARAM_KEY = 'marketingParams';
    const maxAge = 60 * 60 * 24 * 30; // 30 days

    const getMarketingParams = () => {
        const query = getQueryParams() || {};
        return (
            flow([Object.entries, (arr) => arr.filter(([key]) => marketingParamsKeys.includes(key)), Object.fromEntries])(
                query
            ) || {}
        );
    };

    const saveMarketingParams = () => {
        const now = Math.floor(Date.now() / 1000);
        const localParams = JSON.parse(localStorage.getItem(MARKETING_PARAM_KEY) || JSON.stringify({}));
        const { timestamp } = localParams;
        if (timestamp && timestamp + maxAge < now) {
            localStorage.removeItem(MARKETING_PARAM_KEY);
        }

        const params = getMarketingParams();

        if (!isEmpty(params)) {
            const timestamp = now;
            localStorage.setItem(MARKETING_PARAM_KEY, JSON.stringify({ params, timestamp }));
        }
    };

    const init = () => {
        saveMarketingParams();
    };

    init();
})();
